import { createEvent } from 'effector';

export const changeIsAbsoluteEv = createEvent();

export const changeAbsoluteLayersEv = createEvent();

export const putRawDataEv = createEvent();

export const resetAbsoluteLayersEv = createEvent();
